import React from 'react';
import styled from 'styled-components';
import uuid from 'uuid';

import { ModalContainer } from 'shared/modals';
import { Button } from 'shared/components';
import { usePromotionPopUp } from './use-promotion-popup';

// This is being used as the unique identifier to hide the kiosk platform checkbox/option when editing
export const PAY_BY_BANK_ALT_TXT = 'Pay by Bank - Cannabis Payment Processing';

export const dutchiePayImageBanner = {
  _id: uuid.v4(),
  image: 'https://images.dutchie.com/pay/pay-by-bank-banner-desktop.png',
  mobileImage: 'https://images.dutchie.com/pay/pay-by-bank-banner-mobile.png',
  alt: PAY_BY_BANK_ALT_TXT,
  link: '',
  position: 0,
  platforms: [{ enabled: false, link: '', type: 'kiosk' }],
};

export function PromotionPopup(): JSX.Element {
  const { isOpen, loading, handleClose, seenPromotionModal, enableBanner } = usePromotionPopUp();

  return (
    <PromotionModal
      isOpen={isOpen}
      onRequestClose={handleClose}
      width='620px'
      fancy
      alignItems='center'
      pt='90px'
      ariaHideApp={false}
    >
      <Image src='https://images.dutchie.com/pay/pay-by-bank-banner-desktop.png' />
      <ModalTitle>Enable the Pay by Bank banner to increase basket sizes by up to 20%</ModalTitle>
      <ModalContent>
        Click the button below to enable the Pay by Bank banner on your menu. Our research shows that this banner drives
        significantly higher usage on Pay by Bank, leading to larger average order values and more revenue for your
        store.
      </ModalContent>
      <StyledButton onClick={enableBanner} loading={loading}>
        ENABLE BANNER
      </StyledButton>
      <TextButton onClick={seenPromotionModal}>No Thanks</TextButton>
    </PromotionModal>
  );
}

const PromotionModal = styled(ModalContainer)`
  padding: 16px 16px 40px;
  font-size: 14px;
`;

const Image = styled.img`
  max-width: 580px;
  border-radius: 12px;
  margin-bottom: 16px;
`;

const ModalTitle = styled.h1`
  font-weight: 700;
  font-size: 18px;
  line-height: 120%;
  color: #393d40;
  max-width: 380px;
  margin-bottom: 16px;
`;

const ModalContent = styled.p`
  line-height: 165%;
  color: #5d666d;
  max-width: 380px;
`;

const StyledButton = styled(Button)`
  padding: 0 24px;
  margin: 20px 0;
`;

const TextButton = styled.span`
  line-height: 120%;
  color: #0b99e6;
  cursor: pointer;
`;
